export function getCookie(name: string): string | null {
    const match = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return match ? decodeURIComponent(match[2]) : null;
}

export function setCookie(name: string, value: boolean | string, days: number): void {
    const expires = new Date();
    expires.setDate(expires.getDate() + days);
    document.cookie = `${name}=${encodeURIComponent(String(value))}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
}

export function expireCookie(name: string): void {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax`;
}
